module.exports = __webpack_public_path__ + "img/why_img_2.852c48aa.png";